const isBlog = (path: string) => {
  return path.startsWith(`/blog/`) || path === `/blog`;
};

export default isBlog;
